<div class="message-with-action">
  <div class="message-with-action-badge">
    <span class="message-with-action-icon" [style.mask-image]="'url(' + icon() + ')'"
      [style.-webkit-mask-image]="'url(' + icon() + ')'"></span>
  </div>
  <h4 class="message-with-action-title">{{ titleKey() | translate }}</h4>
  <p class="message-with-action-message">{{ messageKey() | translate }}</p>
  <mbp-button data-testid="message-with-action-btn" [type]="actionType()" [svg]="actionSvg()"
    [text]="actionTextKey() | translate" [disabled]="actionDisabled()" (buttonClick)="onAction()"></mbp-button>
</div>
